import React from 'react';
const Contact = () => (
    <div>
      <h1 className="title is-1" style={{color: 'black'}}>Contact me</h1>
      <p style={{color: 'black'}}>
        C O N T A C T M E
      </p>
    </div>
  );
export default Contact;